import { selectmenuAccessibilityCompliance } from '../utilities/helper';
import { jsonGet } from '../components/ajax';
import { API_REFERENCE } from '../utilities/constant_api';
import { iosSelectmenuAccessibilityFixes } from '../utilities/utility';
(function($, doc) {
  const stateSelect = $('.insurance-checker-form select[name=state]');
  const providerSelect = $('.insurance-checker-form select[name=provider]');
  const providerContainer = $('.insurance-checker-form .label-provider');
  const covered = $('.insurance-checker-form .status.covered');
  const notCovered = $('.insurance-checker-form .status.not-covered');
  
  var previousSearchQuery = '';
  var searchItem = null;
  var selectedSearchItem = null;
  var searchTimer = null;
  var nonSearchTimer = null;
  var select2searchField;

  function handleStateSelect() {
    notCovered.hide();
    covered.hide();
    if (
      sessionStorage.getItem('InsuranceVerificationState') !== $(this).val()
    ) {
      sessionStorage.removeItem('InsuranceVerificationProvider');
      sessionStorage.setItem('InsuranceVerificationState', $(this).val());
    }

    if (
      $(this).val() !== undefined &&
      $(this).val() !== null &&
      $(this).val() !== ''
    ) {
      const url = `${
        API_REFERENCE.insuranceVerificationChecker.getInsuranceProviders
      }${$(this).val()}`;
      jsonGet(url).then(data => {
        fillProviderSelect(data);
        /*const providerSelectMenu = providerSelect.siblings(
          '.ui-selectmenu-button'
        );*/
        /*if (providerSelectMenu.length) {
          providerSelect.selectmenu('refresh');
        } else {
          providerSelect.selectmenu({
            open: function() {
              iosSelectmenuAccessibilityFixes($(this));
            },
            close: function() {
              $(this)
                .next('.ui-selectmenu-button')
                .focus();
            }
          });
          selectmenuAccessibilityCompliance();
        }*/
      });
    }
  }

  function fillProviderSelect(data) {
    if (providerSelect.find('option').length > 0) {
      providerSelect.select2('destroy');
    }
    providerSelect.empty();
    providerSelect.append(
      $('<option></option>')
        .val('')
        .html('Provider')
        .prop('disabled', true)
        .prop('selected', true)
    );

    const providers = data.response != null && data.response.hasOwnProperty("docs") ? data.response.docs : [];//data.response.docs;
    
    providers.forEach(provider => {
      providerSelect.append(
        $('<option></option>')
          .val(provider.planCompanyName)
          .html(provider.planCompanyName)
          .attr('data-contract-id', provider.contractStatus_t)
      );
    });
    providerContainer.show();
    providerSelect
      .select2({ width: '100%', matcher: matchCustom })
      .off('select2:select')
      .on('select2:select', handleProviderSelect);
    providerSelect.off('select2:open').on('select2:open', function(){
		previousSearchQuery = '';
		searchItem = null;
		//selectedSearchItem = null;
		$('.select2-container--open .select2-dropdown').addClass('select2-insurance-verification-dropdown');
		select2searchField = $('.select2-search__field');
		select2searchField.off('input').on('input', searchInputCallback);
	});

    if (sessionStorage.getItem('InsuranceVerificationProvider')) {
      $(
        `.insurance-checker-form select[name=provider] option[value="${sessionStorage.getItem(
          'InsuranceVerificationProvider'
        )}"]`
      ).prop('selected', true);
      providerSelect
        .val(sessionStorage.getItem('InsuranceVerificationProvider'))
        .trigger('change')
        .trigger('select2:select');

      // handleProviderSelect.bind(providerSelect)();
    }
  }

  function handleProviderSelect() {
    sessionStorage.setItem('InsuranceVerificationProvider', $(this).val());
    if (
      $(this)
        .find('option:selected')
        .attr('data-contract-id') === 'CONTRACTED'
    ) {
      covered.show();
      notCovered.hide();
    } else {
      covered.hide();
      notCovered.show();
    }
  }
  
  function init() {
    /*stateSelect.selectmenu({
      open: function() {
        iosSelectmenuAccessibilityFixes($(this));
      },
      close: function() {
        $(this)
          .next('.ui-selectmenu-button')
          .focus();
      }
    });*/
    //stateSelect.on('selectmenuchange', handleStateSelect);

    stateSelect.select2({ width: '100%', matcher: matchCustom });
    stateSelect.on('select2:select', handleStateSelect);
    stateSelect.on('select2:open', function(){
		previousSearchQuery = '';
		searchItem = null;
		//selectedSearchItem = null;
		$('.select2-container--open .select2-dropdown').removeClass('select2-insurance-verification-dropdown');
		select2searchField = $('.select2-search__field');
		select2searchField.off('input').on('input', searchInputCallback);
	});
    //providerSelect.on('selectmenuchange', handleProviderSelect);

    if (sessionStorage.getItem('InsuranceVerificationState')) {
      /*$(
          `.insurance-checker-form select[name=state] option[value=${sessionStorage.getItem(
            'InsuranceVerificationState'
          )}]`
        ).prop('selected', true);
        handleStateSelect.bind(stateSelect)();*/
      stateSelect
        .val(sessionStorage.getItem('InsuranceVerificationState'))
        .trigger('change')
        .trigger('select2:select');
    }
  }
  
  function searchInputCallback(e){
		e.stopPropagation();
		//console.log("Search Query.....................");
		//console.log($(this).val());
		
		if($(this).val()==''){
			previousSearchQuery = '';
			searchItem = null;
			selectedSearchItem = null;
			clearTimeout(nonSearchTimer);
			clearTimeout(searchTimer);
			nonSearchTimer = null;
			searchTimer = null;
		}
		
		if(($(this).val().length - previousSearchQuery.length)>=0){
			if(nonSearchTimer != null){ clearTimeout(nonSearchTimer);nonSearchTimer = null;}
			nonSearchTimer = setTimeout(function(){
        $(".select2-results__options").find('li').removeAttr('aria-selected').removeClass('select2-results__option--highlighted');
				setScrollonCustomSearch(selectedSearchItem);
				clearTimeout(nonSearchTimer);
				nonSearchTimer = null;
			},150)
		}
  }
  
  function matchCustom(params, data) {
	    // If there are no search terms, return all of the data
	    if ($.trim(params.term) === '') {
			previousSearchQuery = '';
	      return data;
	    }
	
	    // Do not display the item if there is no 'text' property
	    if (typeof data.text === 'undefined') {
	      return null;
	    }
	    if(data.disabled && data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0){return null;}//For State or Provider disbaled text ignore in search
	    
	    	
	    // `params.term` should be the term that is used for searching
	    // `data.text` is the text that is displayed for the data object
	    if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0 && previousSearchQuery.length != params.term.length ) {//&& previousSearchQuery.length != params.term.length){
			//console.log('------------------------------------------------------')
			//console.log(data)
		  previousSearchQuery = params.term;
		  selectedSearchItem = data;
		  setScrollonCustomSearch(selectedSearchItem);
	    } 
	    
	    return data;
  	}
  	function setScrollonCustomSearch(data){
		if(searchTimer != null){clearTimeout(searchTimer);searchTimer = null; }
		
		searchTimer = setTimeout(function(){
			if(data != undefined){
				searchItem = $(".select2-results__options").find(`li[data-select2-id='select2-data-${data._resultId}']`)[0];
			}
			document.getElementById($(".select2-results__options").attr("id")).scrollTop = $(searchItem).outerHeight() * $(searchItem).index() - 10;
			$(searchItem).attr('aria-selected', true).addClass('select2-results__option--highlighted');
			clearTimeout(searchTimer);
			searchTimer = null;
		},10); 
	}
  init();
})(jQuery, document);
